import { CustomFieldDTO } from '../types/customField'
import api from './axios'

const baseUrl = '/rest/v1/custom-fields'

export async function getCustomFields(params?: PagedRequestParams): Promise<PagedResult<CustomFieldDTO>> {
    const body = params ? {
        params: {
            offset: params.offset,
            limit: params.limit,
            sortField: params.sortField,
            sortOrder: params.sortOrder,
            ...params.filters
        }
    } : {}

    const res = await api.get(baseUrl, body)
    return res.data
}

export async function createCustomField(data: CustomFieldDTO): Promise<ErrorMessage | CustomFieldDTO> {
    const { id, ...payload } = data
    const res = await api.post(baseUrl, payload)
    return res.data
}

export async function updateCustomField(data: CustomFieldDTO): Promise<ErrorMessage | CustomFieldDTO> {
    const { id, ...payload } = data
    const res = await api.put(`${baseUrl}/${id}`, payload)
    return res.data
}

export async function deleteCustomField(id: string): Promise<ErrorMessage | void> {
    return await api.delete(`${baseUrl}/${id}`)
}